import React from 'react';
import { Link } from 'react-router-dom';
import arrow from '../../images/menu-active.svg';
import rectangle from '../../images/menu-base.svg';
import activeRectangle from '../../images/menu-expanded.svg';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getSideNavToggle, getReportLink, getReportMenu, cleanReportMenu } from '../../actions/Page/PageAction';
import { getPageHeaderZIndex } from '../../actions/Page/PageAction';
import { identity } from 'ramda';
import { Fragment } from 'react';
import queryString from 'query-string';
import {
  ADMINISTRATOR_USER,
  ASSOCIATION_USER,
  INSTITUTION_USER,
  SUPER_USER,
} from '../../actionTypes/Users/UserActionType';
import { compareIgnoreCase } from '../../utils/helpers';

class SideNav extends React.Component {
  state = {
    number: -1,
    previousNumber: -1,
    overlay: false,
    linkName: this.props.linkName,
    type: '',
    selectedSubMenu: '',
    activeItem: null,
  };

  constructor(props) {
    super(props);
    this.menuItemsRef = [];
    this.closeSubMenusRef = null;
  }

  getReportMenuClientId() {
    const userRole = this.props.userRoleConstant;
    const activeCasDetailsClientId = this.props.activeCasDetailsClientId;
    const reportMenuClientId =
      userRole === INSTITUTION_USER ? this.props.institutionClientId : activeCasDetailsClientId;
    return userRole === SUPER_USER ? null : reportMenuClientId;
  }

  toggleMainMenu(e) {
    this.props.getSideNavToggle(this.props.sideNavToggle ? false : true);
  }

  getReportMenus() {
    const reportMenuClientId = this.getReportMenuClientId();
    reportMenuClientId && this.props.reportMenuClientId != reportMenuClientId
      ? this.props.getReportMenu(reportMenuClientId)
      : void 0;
  }

  componentDidUpdate(prevProps) {
    if (prevProps.navTriggerFocus !== this.props.navTriggerFocus) {
      this.menuItemsRef[this.state.number].focus();
    }
    this.getReportMenus();
  }

  componentDidMount() {
    this.getReportMenus();
    if (this.props.linkName === 'reports') {
      const queryParams = new URLSearchParams(document.location.search);
      const mainNumber = queryParams.get('main');
      this.setState({
        number: Number(mainNumber),
        previousNumber: Number(mainNumber),
        type: 'main',
        selectedSubMenu: queryParams.get('sub'),
      });
    }
  }

  toggleSubMenu(e, index, item, report, type, previousNumber) {
    e.stopPropagation();
    const toggle = item.subMenu;
    this.props.getPageHeaderZIndex(false);
    if (type === 'sub') {
      this.setState({
        previousNumber,
      });
    }
    if (type === 'main') {
      this.setState({
        previousNumber: index,
        selectedSubMenu: report.reportDisplayName,
      });
    }
    this.setState({
      linkName: '',
      type: type,
      overlay: toggle,
      subMenu: toggle,
      number: index,
      activeItem: item,
    });
    if (report.reportUrl !== '') {
      report.originalUrl = report.reportUrl;
      report.passByUD = false;
      report.saved = false;
      report.cohortObj = {};
      this.props.getReportLink(report);
      this.setState({
        linkName: 'reports',
      });
    }
  }

  overlayClose(e) {
    e.stopPropagation();
    const routeName = this.props.linkName;
    this.setState({
      subMenu: false,
      overlay: false,
      activeItem: null,
    });
    if (routeName === 'reports') {
      this.setState({
        number: this.state.previousNumber,
        type: 'main',
        linkName: 'reports',
      });
    } else {
      this.setState({
        number: -1,
        previousNumber: -1,
      });
    }
    this.closeSubMenusRef = null;
    this.menuItemsRef[this.state.number].focus();
  }

  renderMenus() {
    const { reportMenu, sideNavToggle } = this.props;
    const previousNumber = this.state.previousNumber;
    let selectedTabIndex = this.state.number;
    if (this.state.linkName === 'reports' && this.props.linkName !== 'reports') {
      selectedTabIndex = -1;
    }
    let ReportUrl = {
      reportUrl: '',
    };
    if (reportMenu.length) {
      return reportMenu.map((item, index) => {
        const { menuDisplayName } = item;
        return (
          <li
            tabIndex={sideNavToggle ? '-1' : '0'}
            role="treeitem"
            aria-expanded={selectedTabIndex === index}
            aria-label={`open ${menuDisplayName} reports submenu`}
            ref={(ref) => (this.menuItemsRef[index] = ref)}
            key={index}
            className={'menu-item mYSm-15 ' + (selectedTabIndex === index ? 'active' : 'unselected')}
            onClick={(e) => this.toggleSubMenu(e, index, item, ReportUrl, 'sub', previousNumber)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                this.toggleSubMenu(e, index, item, ReportUrl, 'sub', previousNumber);
              }
              if (e.key === 'Tab' && this.closeSubMenusRef) {
                e.preventDefault();
                this.closeSubMenusRef.focus();
              }
            }}>
            <div className="menu-select-item">
              {this.renderSubNavTab(selectedTabIndex === index, 'main')}
              <a>{menuDisplayName}</a>
            </div>
          </li>
        );
      });
    }
  }

  renderSubMenus(subMenuList, indexParent) {
    const previousNumber = this.state.previousNumber;
    let selectedSubMenuVar = this.state.selectedSubMenu;
    if (this.props.linkName !== 'reports') {
      selectedSubMenuVar = '';
    }
    if (subMenuList.length) {
      return subMenuList.map((item, index) => {
        return (
          <li
            role="presentation"
            key={index}
            className={'submenu-item ' + (selectedSubMenuVar === item.reportDisplayName ? 'active' : 'unselected')}>
            <Link
              to={'/reports?main=' + indexParent + '&sub=' + item.reportDisplayName}
              className="pXSm-15 pYSm-20 show"
              label="Reports"
              role="treeitem"
              tabIndex={0}
              onClick={(e) => {
                this.toggleSubMenu(e, indexParent, false, item, 'main', previousNumber);
              }}
              onKeyDown={(e) => {
                if (e.key === 'Tab' && !e.shiftKey) {
                  const lastElement = subMenuList.length - 1 === index;
                  if (lastElement) {
                    e.preventDefault();
                    this.closeSubMenusRef.focus();
                  }
                }
              }}
              aria-label={item.reportDisplayName}>
              <div className="sub-menu-icon mBottom-20">
                <i className={'' + (item.icon !== '' ? item.icon : '')}></i>
              </div>
              {item.reportDisplayName}
            </Link>
          </li>
        );
      });
    }
  }

  renderSubNavTab(status, type) {
    if (status && type === 'sub') {
      return <img src={activeRectangle} className="menu-item-img-active" alt="logo" />;
    } else if (status && type === 'main') {
      return <img src={arrow} className="menu-item-img-arrow" alt="logo" />;
    } else {
      return <img src={rectangle} className="menu-item-regular" alt="logo" />;
    }
  }

  renderMenu() {
    const { sideNavToggle } = this.props;
    const nameClass = !!this.props.userPersonated ? 'side-nav-fixed top-more ' : 'side-nav-fixed ';
    return (
      <div className={['sideNav', this.state.overlay ? 'side-nav-submenu-opened' : null].filter(identity).join(' ')}>
        <div
          className={'overlay ' + (this.state.overlay ? 'overlay-active' : 'overlay-remove')}
          onClick={(e) => this.overlayClose(e)}></div>
        <div className={nameClass + (sideNavToggle ? 'mainMenuClose' : 'mainMenuOpen')}>
          <nav aria-label={'dashboard switcher'} className="inner-container">
            <button
              aria-label={`toggle report menu ${sideNavToggle ? 'collapsed' : 'expanded'}`}
              aria-checked={!sideNavToggle}
              role="switch"
              data-testid="toggle-btn"
              style={{ position: 'absolute', right: '-26px' }}
              className="close-main-menu pXSm-5 pYSm-10 fontSm-24"
              onClick={(e) => this.toggleMainMenu(e)}>
              <i className={'fa ' + (sideNavToggle ? 'fa-chevron-right' : 'fa-chevron-left')}></i>
            </button>
            <div className="sidenav-menu-wrapper">
              <ul aria-hidden={sideNavToggle} role="tree" id="main-sidenav-reports-tree" className="sidenav-dashboard">
                {this.renderMenus()}
              </ul>
            </div>
            {this.state.activeItem ? (
              <div className={'sub-menu subMenuOpen'}>
                <div className="sub-menu-toggle">
                  <span
                    tabIndex={0}
                    role="button"
                    ref={(ref) => (this.closeSubMenusRef = ref)}
                    aria-label={`close ${this.state.activeItem.menuDisplayName} reports submenu.`}
                    onClick={(e) => this.overlayClose(e)}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        this.overlayClose(e);
                      }
                      if (e.shiftKey && e.key === 'Tab') {
                        e.preventDefault();
                      }
                    }}>
                    {' '}
                    <i className="far fa-times"></i>{' '}
                  </span>
                </div>
                <div className="scroll-max">
                  <ul role="tree" aria-describedby="main-sidenav-reports-tree" className="ul-cust submenu-group">
                    {this.renderSubMenus(this.state.activeItem.reports, this.state.number)}
                  </ul>
                </div>
              </div>
            ) : (
              void 0
            )}
          </nav>
        </div>
      </div>
    );
  }

  canRender() {
    const { userDetails, loggedUserDetails, userRoleConstant, reportMenu } = this.props;
    if (
      [ADMINISTRATOR_USER, ASSOCIATION_USER].includes(userRoleConstant) &&
      compareIgnoreCase(userDetails.userManagementAccess, 'True')
    ) {
      return false;
    }

    return SUPER_USER !== userRoleConstant && reportMenu.length;
  }

  render() {
    console.log('this.canRender()=> ', this.canRender());
    return this.canRender() ? this.renderMenu() : <Fragment></Fragment>;
  }
}

function mapStateToProps(state) {
  return {
    activeCasDetailsClientId: state.AppSession.activeCasDetails.clientId,
    reportMenuClientId: state.Page.reportMenus.clientId,
    institutionClientId: state.AppSession.institutionDetails.institutionClientId,
    reportMenu: state.Page.reportMenus.reportMenus,
    userRoleConstant: state.AppSession.userDetails.userRoleConstant,
    sideNavToggle: state.Page.sideNavToggle,
    navTriggerFocus: state.Page.navTriggerFocus,
    userPersonated: state.Impersonate.impersonate.userPersonated?.impersonating,
    userDetails: state.AppSession.userDetails,
    loggedUserDetails: state.AppSession.userDetails,
  };
}
//userManagementAccess

function matchDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      cleanReportMenu,
      getReportMenu,
      getSideNavToggle,
      getReportLink,
      getPageHeaderZIndex,
    },
    dispatch,
  );
}

export default connect(
  mapStateToProps,
  matchDispatchToProps,
)(
  React.memo(SideNav, (prev, next) => {
    const eq =
      prev.reportMenuClientId === next.reportMenuClientId &&
      prev.sideNavToggle === next.sideNavToggle &&
      prev.reportMenu === next.reportMenu &&
      prev.institutionClientId === next.institutionClientId &&
      prev.activeCasDetailsClientId === next.activeCasDetailsClientId;
    return eq;
  }),
);
